import React from 'react';
import { Icon } from './Icon.js';
export const IconBoxArchive = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("rect", { x: "3", y: "4", width: "14", height: "2", rx: ".5", ry: ".5", fill: "currentColor", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("path", { d: "m3,9v4c0,2.206,1.794,4,4,4h6c2.206,0,4-1.794,4-4v-4H3Zm9,4h-4c-.553,0-1-.448-1-1s.447-1,1-1h4c.553,0,1,.448,1,1s-.447,1-1,1Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconBoxArchive.js.map